import * as tslib_1 from "tslib";
import { getCalendarOptions, saveCalendarProcessingOptions, updateCalendarProcessingOptions, } from 'owa-calendar-processing-configuration';
import getForwardMeetingNotificationOption from '../selectors/getForwardMeetingNotificationOption';
import getOldMeetingMessgeOption from '../selectors/getOldMeetingMessageOption';
import logDataOnSaveInvitations from '../utils/logDataOnSaveInvitations';
/*
    Called when clicked on save button in calendar settings panel.
    Updates user options so that the changes are reflected in current user session
    Updates the calendar processing configuration on local store and on server
*/
export default function saveInvitationOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var calendarProcessingConfiguration, newOldMeetingMessagesStatus, newForwardedMeetingNotificationsStatus;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    calendarProcessingConfiguration = getCalendarOptions();
                    newOldMeetingMessagesStatus = getOldMeetingMessgeOption();
                    newForwardedMeetingNotificationsStatus = getForwardMeetingNotificationOption();
                    updateCalendarProcessingOptions({
                        RemoveOldMeetingMessages: newOldMeetingMessagesStatus,
                        RemoveForwardedMeetingNotifications: newForwardedMeetingNotificationsStatus,
                    });
                    // save the new calendar configuration at server
                    return [4 /*yield*/, saveCalendarProcessingOptions(calendarProcessingConfiguration)];
                case 1:
                    // save the new calendar configuration at server
                    _a.sent();
                    logDataOnSaveInvitations();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=saveInvitationOption.js.map